module.exports = __webpack_public_path__ + "media/printed-materials/educators-03-app-poster-d989a0e9.jpg";